export function isAskInputVoiceToVoiceEnabled({ showVoice, isMissionControl, isFollowUp, isCometHome, isMobileUserAgent, isMobileStyle, sidecarBuildFlag, }) {
    return (showVoice &&
        !isMissionControl &&
        !isFollowUp &&
        !isCometHome &&
        ((!isMobileUserAgent && !isMobileStyle) || !!sidecarBuildFlag));
}
//# sourceMappingURL=isAskInputVoiceToVoiceEnabled.js.map